import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ConnectToChannelPopup } from './ConnectToChannelPopup';

export const CONNECT_TO_CHANNEL_POPUP = Symbol('CONNECT_TO_CHANNEL');

export const useConnectToChannelPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CONNECT_TO_CHANNEL_POPUP, ConnectToChannelPopup);
  });

  return useCallback(
    ({
      brandVoiceId,
      onConnectSuccess,
      displayIntegrations,
      displayResourcesTemplates,
      displayEmailIntegrations,
      displayBlogURLs,
      displayTalkingPointsFromResource,
      hideWtmIntegration,
      title,
      subtitle,
      isTrainingModel,
    }) => {
      return new Promise((resolve) => {
        popups.openPopup(CONNECT_TO_CHANNEL_POPUP, {
          onClose: () => {
            popups.closePopup(CONNECT_TO_CHANNEL_POPUP);
            resolve();
          },
          onSubmit: (channel) => {
            popups.closePopup(CONNECT_TO_CHANNEL_POPUP);
            resolve(channel);
          },
          brandVoiceId,
          onConnectSuccess,
          displayIntegrations,
          displayResourcesTemplates,
          displayEmailIntegrations,
          displayBlogURLs,
          displayTalkingPointsFromResource,
          hideWtmIntegration,
          title,
          subtitle,
          isTrainingModel,
        });
      });
    },
    [popups]
  );
};
